export default __webpack_public_path__ + "static/media/starwarsinfo.dbc9fdb5.gif";